import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { PAGE_TYPES } from '@/components/blocks/pageTypes';
import { useStore } from 'vuex';

export default function useListData() {
  const route = useRoute();
  const store = useStore();
  const pageType = ref('');
  const getData = ref('');
  const getIsLoading = ref('');
  const filterComponent = ref('');
  const setSearch = ref('');
  const getSearch = ref('');
  const pageName = route.name;

  switch (pageName) {
    case 'History':
      getData.value = (state) => state.lots.lotHistory;
      getIsLoading.value = (state) => state.lots.isLoading;
      pageType.value = PAGE_TYPES.HISTORY;
      filterComponent.value = 'FilterHistory';
      break;
    case 'MyPurchases':
    case 'FavoritePurchases':
    case 'ActualPurchases':
      getData.value = (state) => state.lots.list.lots;
      getIsLoading.value = (state) => state.lots.isLoading;
      pageType.value = PAGE_TYPES.LOTS;
      // getSearch.value = () => store.state.lots.search;
      // setSearch.value = (search) => store.dispatch('lots/setSearch', search);
      filterComponent.value = 'Filter';
      break;
    case 'ArchivePurchases':
      getData.value = (state) => state.lots.list.lots;
      getIsLoading.value = (state) => state.lots.isLoading;
      pageType.value = PAGE_TYPES.LOTS;
      filterComponent.value = 'Filter';
      break;
    case 'Documents':
      getData.value = (state) => state.lots.documents.documents;
      getIsLoading.value = (state) => state.lots.isLoading;
      pageType.value = PAGE_TYPES.DOCUMENTS;
      filterComponent.value = 'FilterDocuments';
      break;
    case 'PlannedPurchases':
      getData.value = (state) => state.lots.list.lots;
      getIsLoading.value = (state) => state.lots.isLoading;
      pageType.value = PAGE_TYPES.LOTS;
      filterComponent.value = 'Filter';
      break;
    case 'CustomerOrganizations':
      getData.value = (state) => state.admin.organizations.list;
      getIsLoading.value = (state) => state.admin.isLoading;
      pageType.value = PAGE_TYPES.ORGANIZATIONS;
      getSearch.value = (state) => state.admin.customerOrganizationsSearch;
      setSearch.value = (search) => store.dispatch('admin/setCustomerOrganizationsSearch', search);
      break;
    case 'PartnerOrganizations':
      getData.value = (state) => state.admin.organizations.list;
      getIsLoading.value = (state) => state.admin.isLoading;
      pageType.value = PAGE_TYPES.ORGANIZATIONS;
      getSearch.value = (state) => state.admin.partnerOrganizationsSearch;
      setSearch.value = (search) => store.dispatch('admin/setPartnerOrganizationsSearch', search);
      break;
    case 'GeneralContractors':
      getData.value = (state) => state.admin.organizations.list;
      getIsLoading.value = (state) => state.admin.isLoading;
      pageType.value = PAGE_TYPES.GENERAL_CONTRACTORS;
      getSearch.value = (state) => state.admin.genContractorOrganizationsSearch;
      setSearch.value = (search) => store.dispatch('admin/setGeneralContractorsSearch', search);
      filterComponent.value = 'FilterGenContractor';
      break;
    case 'GenContractorLotsList':
      getData.value = (state) => state.genContractorLots.list.lots;
      getIsLoading.value = (state) => state.genContractorLots.isLoading;
      pageType.value = PAGE_TYPES.GEN_CONTRACTOR_LOTS_LIST;
      getSearch.value = (state) => state.genContractorLots.search;
      setSearch.value = (search) => store.dispatch('genContractorLots/setSearch', search);
      filterComponent.value = 'FilterGenContractorLots';
      break;
    case 'ContractWorksList':
      getData.value = (state) => state.contractWorksList.list.contracts;
      getIsLoading.value = (state) => state.contractWorksList.isLoading;
      pageType.value = PAGE_TYPES.CONTRACT_WORK_LIST;
      getSearch.value = (state) => state.contractWorksList.search;
      setSearch.value = (search) => store.dispatch('contractWorksList/setSearch', search);
      filterComponent.value = 'FilterContractWorkList';
      break;
    case 'ContractWorksListArchive':
      getData.value = (state) => state.contractWorksList.list.contracts;
      getIsLoading.value = (state) => state.contractWorksList.isLoading;
      pageType.value = PAGE_TYPES.CONTRACT_WORK_LIST;
      getSearch.value = (state) => state.contractWorksList.search;
      setSearch.value = (search) => store.dispatch('contractWorksList/setSearch', search);
      filterComponent.value = 'FilterContractWorkList';
      break;
    case 'Objects':
      getData.value = (state) => state.admin.objects.list;
      getIsLoading.value = (state) => state.admin.isLoading;
      pageType.value = PAGE_TYPES.OBJECTS;
      getSearch.value = (state) => state.admin.objectsSearch;
      setSearch.value = (search) => store.dispatch('admin/setObjectsSearch', search);
      break;
    case 'CustomerOrganizationDetails':
      getData.value = (state) => state.admin.organizationDetails.users;
      getIsLoading.value = (state) => state.admin.isLoading;
      pageType.value = PAGE_TYPES.ORGANIZATION_DETAILS;
      break;
    case 'PartnerOrganizationDetails':
      getData.value = (state) => state.admin.organizationDetails.users;
      getIsLoading.value = (state) => state.admin.isLoading;
      pageType.value = PAGE_TYPES.ORGANIZATION_DETAILS;
      break;
    case 'СontractList':
      getData.value = (state) => state.contracts.list.contracts;
      getIsLoading.value = (state) => state.contracts.isLoading;
      pageType.value = PAGE_TYPES.CONTRACTS;
      setSearch.value = (search) => store.dispatch('contracts/setSearch', search);
      break;
    case 'ProtocolList':
      getData.value = (state) => state.protocols.list.protocols;
      getIsLoading.value = (state) => state.protocols.isLoading;
      pageType.value = PAGE_TYPES.PROTOCOLS;
      setSearch.value = (search) => store.dispatch('protocols/setSearch', search);
      break;
    case 'SupplyRequestList':
      getData.value = (state) => state.supplyRequest.list.supplyRequests;
      getIsLoading.value = (state) => state.supplyRequest.isLoading;
      pageType.value = PAGE_TYPES.SUPPLYREQUEST;
      setSearch.value = (search) => store.dispatch('supplyRequest/setSearch', search);
      break;
    case 'SupplyTaskList':
      getData.value = (state) => state.supplyTask.list.supplyTasks;
      getIsLoading.value = (state) => state.supplyTask.isLoading;
      pageType.value = PAGE_TYPES.SUPPLYTASK;
      setSearch.value = (search) => store.dispatch('supplyTask/setSearch', search);
      break;
    case 'ClarificationsList':
      getData.value = (state) => state.clarifications.list.clarifications;
      getIsLoading.value = (state) => state.clarifications.isLoading;
      pageType.value = PAGE_TYPES.CLARIFICATIONS;
      break;
    case 'SupplyTask':
      getData.value = (state) => state.supplyRequest.items;
      getIsLoading.value = (state) => state.supplyRequest.isLoading;
      pageType.value = PAGE_TYPES.SUPPLY_REQUEST_DETAILS;
      break;
    case 'NotificationList':
      getData.value = (state) => state.notifications.list.notifications;
      getIsLoading.value = (state) => state.notifications.isLoading;
      pageType.value = PAGE_TYPES.NOTIFICATIONS;
      break;
    default:
      pageType.value = '';
  }

  return {
    pageType, getData, getIsLoading, filterComponent, getSearch, setSearch,
  };
}
